window.htmx = require('htmx.org');
import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import { nossFilter } from '../../../../../paws/assets/frontend/js/helper/filter';

whenDocumentReady(initModule);
function initModule() {
    let dropdowns = document.querySelectorAll('.noss_vergleich.default select');
    if (dropdowns.length > 0) {
        let choices = [];
        for (let i = 0; i < dropdowns.length; i++) {
            choices[i] = new Choices(dropdowns[i], {
                loadingText: 'Laden...',
                noResultsText: 'Keine Ergebnisse gefunden.',
                noChoicesText: 'Keine Resultate gefunden.',
                itemSelectText: 'Enter oder Klick für Auswahl',
                placeholderValue: 'Meow'
            });
        }
    }

    document.addEventListener('htmx:afterSwap', function(event) {
        if (event.target.classList.contains('result')) {
            htmx.process(event.target);

            let dropdowns = event.target.querySelectorAll('select');
            if (dropdowns.length > 0) {
                let choices = [];
                for (let i = 0; i < dropdowns.length; i++) {
                    choices[i] = new Choices(dropdowns[i], {
                        loadingText: 'Laden...',
                        noResultsText: 'Keine Ergebnisse gefunden.',
                        noChoicesText: 'Keine Resultate gefunden.',
                        itemSelectText: 'Enter oder Klick für Auswahl',
                        placeholderValue: 'Bitte wählen...'
                    });
                }
            }
        }
    });
}
//
//
//
// window.ShowPraemienResults = function() {
//     let sourceForm = document.querySelector('.wsf-form.praemienvergleich');
//     let targetForm = document.querySelector('.noss_praemienvergleich.default form');
//     if (sourceForm !== undefined && targetForm !== undefined) {
//         let zipCity = sourceForm.querySelector('.fld-zipcity').value;
//         let birthYears = sourceForm.querySelectorAll('.fld-birthyear');
//         let franchises = sourceForm.querySelectorAll('.fld-franchise');
//         let accidents = sourceForm.querySelectorAll('.fld-accident');
//
//         let persons = [];
//
//         for (let i = 0; i < birthYears.length; i++) {
//             persons.push({
//                 'birthyear': parseInt(birthYears[i].value),
//                 'franchise': parseInt(franchises[i].value),
//                 'accident': accidents[i].checked,
//             })
//         }
//
//         targetForm.querySelector('#zipcity').value = zipCity;
//         targetForm.querySelector('#persons').value = JSON.stringify(persons);
//         htmx.trigger(targetForm, 'submit');
//     }
// }